class HeaderNavigation extends HTMLElement {
    constructor() {
        super();

        //Number of px to scroll before hidingh the navigation
        this.scrollTreshold = 120;
        this.currentScrollPosition = 0;
        this.debounceTimer;

        this.btnEventListeners();
        this.resizeEventListeners();
        this.updateMarginTop();
        this.scrollEventListeners();

        this.recoveryUrl();
        window.addEventListener('hashchange', () => {
            this.recoveryUrl();
        });

    }

    debounceSearch(query) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.requestNewSearch(query)
        }, 300); // Adjust the delay as needed
    }

    updateMarginTop() {
        const { headerBar, navHeaderWrapper, pageHeaderContainer, announcementBar, mobileNavContent } = this.navigationComponent();
        let totalPadding = 0;
        announcementBar !== null ? totalPadding += announcementBar.offsetHeight : null;
        totalPadding += headerBar.offsetHeight;
        mobileNavContent.style.marginTop = `${totalPadding}px`;

        if(announcementBar !== null) {
            navHeaderWrapper.style.top = `${announcementBar.offsetHeight}px`;
        }

        pageHeaderContainer.style.marginBottom = `${totalPadding * 1.2}px`;

    }

    resizeEventListeners() {
        window.addEventListener('resize', () => {
            this.updateMarginTop();
        });
    }
    
    btnEventListeners() {
        const { mobileToggle, mobileLinks, accountDrawerButton, accountDrawerClose, predictiveSearchToggle, predictiveSearchInput } = this.navigationComponent();

        mobileToggle.addEventListener('click', () => {
            this.updateMarginTop();
            this.toggleMobileNavigation();
        });

        mobileLinks.forEach(link => {
            link.addEventListener('click', () => {
                this.toggleMobileDropdown(link);
            });
        });

        accountDrawerButton.addEventListener('click', () => {
            this.openAccountDrawer();
        })

        accountDrawerClose.forEach(btn => {
            btn.addEventListener('click', () => {
                this.closeAccountDrawer();
            })
        });

        predictiveSearchToggle.forEach(searchToggle => {
            searchToggle.addEventListener('click', () => {
                this.togglePredictiveSearch();
            })
        });

        predictiveSearchInput.addEventListener('input', (e) => {
            const { predictiveResultsGrid } = this.navigationComponent();
            if(e.target.value.length >= 3) {
                this.debounceSearch(e.target.value);
            } else {
                predictiveResultsGrid.classList.add('hidden');
            }
        });
    }
    
    togglePredictiveSearch() { 
        const { predictiveSearchContainer } = this.navigationComponent();
        predictiveSearchContainer.classList.toggle('hidden');
    }

    openAccountDrawer() {
        const { accountDrawer } = this.navigationComponent();

        accountDrawer.classList.toggle('hidden');
        if (!accountDrawer.classList.contains('hidden')) {
            document.body.style.overflow = 'auto';
        }else {
            document.body.style.overflow = 'auto';
        }
    }

    closeAccountDrawer() {
        const { accountDrawer } = this.navigationComponent();

        accountDrawer.classList.replace('animate-drawer-in', 'animate-drawer-out');
        setTimeout(() => {
            accountDrawer.classList.add('hidden');
            accountDrawer.classList.replace('animate-drawer-out', 'animate-drawer-in');
            if(window.innerWidth >= 1200) {
                document.body.style.overflow = 'auto';
            }
        }, 300);
    }

    recoveryUrl() {
        let url = window.location.href;
        const afterHash = url.slice(url.lastIndexOf('#') + 1);
        afterHash == 'recover' ? this.switchView('recovery-form') : this.switchView('login-form');
    }

    switchView(element) {
        const { passwordRecovery, loginForm } = this.navigationComponent();

        if(passwordRecovery.length != 0 && loginForm.length != 0) {
          passwordRecovery.forEach(form => {
              element == 'login-form' ? form.classList.add('hidden') : form.classList.remove('hidden')
          })
          loginForm.forEach(form => {
              element == 'login-form' ? form.classList.remove('hidden') : form.classList.add('hidden')
          })
        }
    }

    scrollEventListeners() {
        window.addEventListener('scroll', () => {
            this.handleScrollNavigation();
        });
    }

    //Show and hide navigation when scrolling
    handleScrollNavigation() {
        const { topNavMenu } = this.navigationComponent();
        const scrollPosition = window.scrollY;

        if(this.currentScrollPosition > scrollPosition) {
            topNavMenu.classList.remove('hidden');
            topNavMenu.classList.remove('animate-navigation-out');
            topNavMenu.classList.add('animate-navigation-in')

        } else if (scrollPosition > this.scrollTreshold) {
            topNavMenu.classList.remove('animate-navigation-in');
            topNavMenu.classList.add('animate-navigation-out');

            setTimeout(() => {
                topNavMenu.classList.add('hidden');
            }, 300);
        }

        this.currentScrollPosition = scrollPosition;
    }

    toggleMobileDropdown(link) {
        const elementToOpen = this.querySelector(`#${link.dataset.open}`);
        const arrow = link.querySelector('.mobile-nav-item-arrow');
        elementToOpen.classList.toggle('hidden');

        if(elementToOpen.classList.contains('hidden')) {
            link.classList.remove('bg-orange');
            link.classList.replace('text-white', 'text-darkGray');
            arrow.classList.replace('rotate-180', 'rotate-0');
        } else {
            link.classList.add('bg-orange');
            link.classList.replace('text-darkGray', 'text-white');
            arrow.classList.replace('rotate-0', 'rotate-180');
        }

    }

    toggleMobileNavigation() {  
        const { mobileNav, hamburgerIcon, closeIcon } = this.navigationComponent();
        mobileNav.classList.toggle('hidden');

        if(mobileNav.classList.contains('hidden')) {
            hamburgerIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            document.body.classList.remove('overflow-hidden');
        } else {
            hamburgerIcon.classList.add('hidden');
            closeIcon.classList.remove('hidden');
            document.body.classList.add('overflow-hidden');
        }

    }

    requestNewSearch(searchTerm) {

        const { predictiveSearchLoading, predictiveResultsGrid } = this.navigationComponent();

        predictiveResultsGrid.classList.remove('hidden');
        fetch(`${window.Shopify.routes.root + "search/suggest.json"}?q=${encodeURIComponent(searchTerm)}&resources[type]=product,article`)
        .then(response => {
            if (!response.ok) {
                throw new Error(response.status);
            }
            return response.json();
        }).then(jsonResults => {

            let totalResults = jsonResults.resources.results.products.length + jsonResults.resources.results.articles.length;

            if(totalResults > 0) {
                predictiveSearchLoading.forEach(loading => {
                    loading.classList.add('hidden');
                });
                this.predictiveUpdateResults(jsonResults.resources.results);
            } else {
                this.predictiveSearchEmptyResults(searchTerm)
            }
        })
    }

    predictiveUpdateResults(results) {
        const { predictiveSearchProduct, predictiveSearchArticle, predictiveSearchEmptyResultsContainer } = this.navigationComponent();

        predictiveSearchEmptyResultsContainer.classList.add('hidden');

        predictiveSearchProduct.innerHTML = '';
        predictiveSearchArticle.innerHTML = '';
        
        if(results.articles.length != 0) {
            predictiveSearchArticle.appendChild(this.predictiveSearchArticleResults(results.articles));
        } else {
            predictiveSearchArticle.innerHTML = '<p class="font-Roboto text-base text-blue-dark">No articles found</p>';
        }

        if(results.products.length != 0) {
            predictiveSearchProduct.appendChild(this.predictiveSearchProductResults(results.products));
        } else {
            predictiveSearchProduct.innerHTML = '<p class="font-Roboto text-base text-blue-dark">No products found</p>';
        }

    }

    predictiveSearchArticleResults(articles) {
        let allArticleResults = document.createElement('div');
        allArticleResults.classList.add('flex', 'gap-y-6', 'flex-col');

        articles.forEach((article, index) => {
            if(index < 3) {
                let articleContainer = document.createElement('div');
                articleContainer.classList.add('flex', 'gap-6', 'items-center');
                articleContainer.innerHTML = `
                    <div>
                        ${ this.renderFeaturedImage(article.featured_image) }
                    </div>
                    <div class="uppercase text-blue-dark font-Roboto text-base">
                        ${ this.truncateString(article.title, 25) } <a href="${ article.url }" class="font-bold"> Read more</a>
                    </div>
                `
                allArticleResults.appendChild(articleContainer);
            }
        });
        return allArticleResults;
    }

    predictiveSearchProductResults(products) {
        let allProductResults = document.createElement('div');
        allProductResults.classList.add('flex', 'gap-y-6', 'flex-col');

        products.forEach((product, index) => {
            if(index < 3) {

                let productWrapper = document.createElement('a');
                productWrapper.href = product.url;

                let productContainer = document.createElement('div');
                productContainer.classList.add('flex', 'gap-6', 'items-center');
                productContainer.innerHTML = `
                    <div>
                        ${ this.renderFeaturedImage(product.featured_image) }
                    </div>
                    
                    <div class="uppercase text-blue-dark font-Roboto text-base">
                        ${ product.title }
                    </div>
                `
                productWrapper.appendChild(productContainer);
                allProductResults.appendChild(productWrapper);
            }
        });
        return allProductResults;
    }

    predictiveSearchEmptyResults(searchTerm) {
        const { predictiveSearchEmptyResultsContainer, predictiveResultsGrid } = this.navigationComponent();

        predictiveSearchEmptyResultsContainer.classList.remove('hidden');
        predictiveResultsGrid.classList.add('hidden');
        predictiveSearchEmptyResultsContainer.querySelector('.predictive-search-no-results-query').innerHTML = searchTerm;

    }

    truncateString(str, maxLength) {
        if (str.length > maxLength) {
          return str.substring(0, maxLength - 3) + '...';
        } else {
          return str;
        }
    }

    renderFeaturedImage(image) {
        if(image.url == null) {
            return `
                <svg 
                    class="object-cover w-[60px] h-[60px] rounded-[20px]" 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 525.5 525.5"
                >
                    <path 
                        d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z">
                    </path>
                </svg>
            `;
        } else {
            return `
                <img 
                    src="${ image.url }" 
                    width="60" 
                    height="60" 
                    class="object-cover w-[60px] h-[60px] rounded-[5px]"
                    alt="${ image.alt }"
                >
            `;
        }
    }

    navigationComponent() {
        const navHeaderWrapper = document.getElementById('navigation-header-wrapper');
        const mobileToggle = this.querySelector('#mobile-nav-toggle');
        const mobileNav = this.querySelector('#mobile-navigation');
        const headerBar = this.querySelector('#main-header-bar');
        const mobileNavContent = this.querySelector('#mobile-navigation-wrapper')
        const hamburgerIcon = this.querySelector('#nav-hamburger-icon');
        const closeIcon = this.querySelector('#nav-close-icon');
        const topNavMenu = this.querySelector('#top-navigation-menu');
        const pageHeaderContainer = document.getElementById('page-header-container');

        const mobileLinks = this.querySelectorAll('.mobile-nav-link');
        const announcementBar = document.querySelector('#announcement-bar');

        const accountDrawerButton = this.querySelector('#account-drawer-button');
        const accountDrawer = this.querySelector('.account-drawer');
        const accountDrawerClose = this.querySelectorAll('.account-drawer-close');
        const passwordRecovery = document.querySelectorAll('.password-recovery');
        const loginForm = document.querySelectorAll('.login-form');

        const predictiveSearchToggle = this.querySelectorAll('.predictive-search-toggle');
        const predictiveSearchContainer = this.querySelector('#predictive-search-container');

        const predictiveResultsGrid = this.querySelector('.predictive-search-results');
        const predictiveSearchProduct = this.querySelector('.search-results-products');
        const predictiveSearchArticle = this.querySelector('.search-results-blogs');
        const predictiveSearchInput = this.querySelector('#predictive-search-input');
        const predictiveSearchLoading = this.querySelectorAll('.predictive-search-loading');
        const predictiveSearchEmptyResultsContainer = this.querySelector('.predictive-search-no-results');

        return { 
            navHeaderWrapper, 
            pageHeaderContainer, 
            topNavMenu, 
            mobileToggle, 
            mobileNav, 
            headerBar, 
            announcementBar, 
            mobileNavContent, 
            hamburgerIcon, 
            closeIcon, 
            mobileLinks,
            accountDrawerButton,
            accountDrawer,
            accountDrawerClose,
            passwordRecovery,
            loginForm,
            predictiveSearchToggle,
            predictiveSearchContainer,
            predictiveResultsGrid,
            predictiveSearchProduct,
            predictiveSearchArticle,
            predictiveSearchInput,
            predictiveSearchLoading,
            predictiveSearchEmptyResultsContainer
        };
    }
}

customElements.define('header-navigation', HeaderNavigation);